<template>
    <div v-if="!isHidden" class="d-flex align-items-center step-indicator" @click="clicked">
        <b-button
            :class="
                isDone
                    ? ['b-avatar p-0 badge-primary step-indicator-button mr-lg-75 rounded', 'active']
                    : ['b-avatar p-0 badge-primary step-indicator-button mr-lg-75 rounded', 'disabled']
            "
            variant="primary"
            :disabled="!isDone"
        >
            {{ stepNumber }}
        </b-button>
        <p :class="labelClass">
            {{ stepTitle }}
        </p>
        <font-awesome-icon
            v-if="!isLast"
            icon="caret-right"
            :class="isDone ? ['my-0 mx-1'] : ['my-0 mx-1', 'text-secondary']"
        />
    </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
    components: {
        BButton,
    },
    props: {
        stepTitle: {
            type: String,
            required: true,
        },
        stepNumber: {
            type: Number,
            required: true,
        },
        isLast: {
            type: Boolean,
            default: false,
        },
        isHidden: {
            type: Boolean,
            default: false,
        },
        isDone: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        labelClass() {
            const textClass = this.isDone
                ? ["m-0", "d-none", "d-xl-block"]
                : ["m-0", "text-secondary", "d-none", "d-xl-block"];

            if (this.isActive) {
                textClass.push("font-weight-bold");
            }

            return textClass;
        },
    },
    methods: {
        clicked() {
            if (!this.isDone) {
                return;
            }
            this.$emit("on-clicked", { stepNumber: this.stepNumber });
        },
    },
    emits: ["on-clicked"],
};
</script>
